import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { servicesStatusSelector } from '../selectors/dashboardSelector';
import { getServicesStatusRequest } from '../actions/dashboardActions';
import MainServicesStatus from '../components/MainServicesStatus/MainServicesStatus';

const mapStateToProps = createStructuredSelector({ servicesStatus: servicesStatusSelector });
const mapDispatchToProps = { getServicesStatusRequest };

export default connect(mapStateToProps, mapDispatchToProps)(MainServicesStatus);
